import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MessageComponent } from 'src/app/shared/components/message/message.component';
import { MaterialModule } from 'src/app/shared/material/material.module';

@Component({
  selector: 'app-update-available',
  standalone: true,
  imports: [CommonModule, MaterialModule, MessageComponent],
  templateUrl: './update-available.component.html',
  styleUrl: './update-available.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateAvailableComponent {
  constructor(private readonly matDialogRef: MatDialogRef<UpdateAvailableComponent>) {}

  protected confirm = () => {
    this.matDialogRef.close(true);
  };
}
